// Click to copy a reference (client ref / budget no., contractor's ref, building code) — shows "Copied".
import { useState } from 'react';
import { useToast } from './kit';

export function CopyText({ value, label, className = '' }: { value: string | null | undefined; label?: string; className?: string }) {
  const toast = useToast();
  const [done, setDone] = useState(false);
  if (!value) return <b className={`ink ${className}`}>—</b>;
  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // older browsers / no permission: select-and-copy fallback
      const ta = document.createElement('textarea');
      ta.value = value;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
    }
    setDone(true);
    setTimeout(() => setDone(false), 1500);
    toast({ tone: 'ok', text: `Copied ${label ? `${label} ` : ''}${value}` });
  };
  return (
    <button type="button" className={`copy-ref ${done ? 'done' : ''} ${className}`} onClick={copy} title={`Copy ${value}`} aria-label={`Copy ${label ?? ''} ${value}`.replace(/\s+/g, ' ')}>
      <span>{value}</span>
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {done ? <path d="M5 13l4 4L19 7" /> : <><rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h10" /></>}
      </svg>
    </button>
  );
}
